The optional family name (or surname) of a person.
